import {Slick} from './query-slick';
import './scroll';
import './portfolio';
// import {getLCP, getFID, getCLS} from 'web-vitals';


(function ($) {
	//console.log('jquery version: ', $.fn.jquery);
	// console.log(LB_Data);

	// Update Copyright date
	document.getElementById("footer-copyright").innerHTML = new Date().getFullYear()

	/**
	 * Sticky Header
	 */
	$(window).scroll(function () {
		var sticky = $('.main-menu'),
			scroll = $(window).scrollTop();
		if (scroll >= 100) {
			sticky.addClass('fixed')
			$('body').addClass('fixed-menu')
		} else {
			$('body').removeClass('fixed-menu')
			sticky.removeClass('fixed');
		}
	});





	/**
	 * Update testimonials
	 */
	let randomPost = LB_Data.posts[Math.floor(Math.random() * LB_Data.posts.length)]

	// Either show a subset of posts, in which case the div will not be .empty
	let ul = document.querySelector('ul.testimonial-posts');
	// for (var i = ul.children.length; i >= 0; i--) {
	// 	ul.appendChild(ul.children[Math.random() * i | 0]);
	// }

	// console.log(randomPost); adaptiveHeight: true
	let $blogtestimonial = $('.blog .testimonial-posts.empty.random:not(.is-style-lb-slick)');
	let $testimonial = $('.testimonial-posts.empty.random:not(.is-style-lb-slick)');
	console.log($testimonial);
	$testimonial.find('.testimonial-excerpt').html(randomPost.post_content);
	$('.random:not(.is-style-lb-slick) .testimonial-source span').text(randomPost.post_title);

	/**
	 * Initialize slick.
	 */
	$(document).ready(function(){
		Slick();
		// $('img').load(function(){
		//
		// 	//your script inside it
		// });
	});

})(jQuery);
